import Vue from 'vue'
import Vuex from 'vuex'
import $hub from 'hub-js';

Vue.use(Vuex);
Vue.prototype.$hub = $hub;

let store = new Vuex.Store({
  state: {
    userList: [],
    user: {},
    init: {}
  },
  computed: {
    hasLogin() {
      return store.state.hasLogin;
    },
    is_mobile: function () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mutations: {
    addUser(state, username) {
      state.userList.push(username)
    },
    created: function () {
      console.log("storage created call");
    },
    login(state, provider) {
      localStorage.setItem('userinfo', JSON.stringify(provider.userinfo));
      localStorage.setItem('token', provider.token);
      state.hasLogin = true
      state.user.token = provider.token
      state.user.userinfo = provider.userinfo
      $hub.emit('event:login', {});
    },
    init: function (state, provider) {
      console.log('init provider:', provider)
      state.init.time = provider.time
      state.init.data = provider.data
      $hub.emit('event:init', provider);
      localStorage.setItem('init', JSON.stringify(state.init));
    },
    loginout: function (state, provider) {
      state.hasLogin = false
      state.user.token = undefined
      state.user.userinfo = undefined
      localStorage.removeItem('userinfo')
      localStorage.removeItem('token')
      $hub.emit('event:loginout', {});
    }
  },
  actions: {
    init() {
      this.dispatch('get_user')
      var init_data = localStorage.getItem('init');
      if (init_data) {
        init_data = JSON.parse(init_data);
        this.state.init = init_data;
      }
    },
    get_user() {
      try {
        var userinfo = localStorage.getItem('userinfo');
        var token = localStorage.getItem('token');
        if (userinfo) {
          userinfo = JSON.parse(userinfo)
        }
        if (token && userinfo) {
          this.state.hasLogin = true;
          this.state.user.token = token
          this.state.user.userinfo = userinfo
          //this.update_userinfo(this.state.user.userinfo)
        }
      } catch (e) {
        console.log('get_user err:', e);
      }
    }
  }
})

export default store